import "core-js/modules/es.object.to-string.js";
export var getValidationMessageStyle = function getValidationMessageStyle(messageList) {
  return messageList ? Array.isArray(messageList) && messageList.length ? messageList.every(function (entry) {
    return "warning" === (null == entry ? void 0 : entry.type);
  }) ? "warning" : "invalid" : "warning" === (null == messageList ? void 0 : messageList.type) ? "warning" : "invalid" : "invalid";
};